var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatRopa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_ropa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-clothing-5",
    d: "M66.937,138.491H34.513l.11-57.712L17.409,131.11,0,126.949l22.972-92.34,23.082-9.967c-5.124-5.448-7.819-13.487,0-18.71,0,0,8.263-5.875,23.191-5.927S92.218,5.758,92.218,5.758c7.652,4.865,5.17,14.243,0,18.872L115.3,34.609l23.191,92.34-17.311,4.213L103.868,80.779l-.11,57.712h-32.2V14.432c8.465-.289,15-2.112,15-4.317,0-2.407-7.756-4.357-17.311-4.357S51.934,7.709,51.934,10.116c0,2.2,6.538,4.028,15,4.317V138.491Zm20.456-40.52-3.722,2.707,13.589,18.664,3.722-2.707Zm-36.3,0,3.722,2.707L41.23,119.342l-3.722-2.707L51.1,97.971Z",
    transform: "translate(30.588 30.683)",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatRopa);
export default __webpack_public_path__ + "static/media/cat_ropa.9efafd0ab2c39c833d21fb9add853c0f.svg";
export { ForwardRef as ReactComponent };